﻿import { onEvent, getById } from "./_dom";
import { ensureVisible } from "./_ensureVisible";

function init(context) {
	function toggleHelp(button, helpbox, show) {
		if (show) {
			button.setAttribute("aria-expanded", "true");
			helpbox.classList.remove("v3-helpbox--hidden");
		} else {
			button.removeAttribute("aria-expanded");
			helpbox.classList.add("v3-helpbox--hidden");
		}
	}
	onEvent(context, ".v3-helpbox-button", "click", (_, button) => {
		const helpVisible = button.getAttribute("aria-expanded") === "true";
		const helpboxId = button.getAttribute("aria-controls");
		const helpbox = getById(context, helpboxId);
		if (helpbox) {
			toggleHelp(button, helpbox, !helpVisible);
			if (!helpVisible) {
				ensureVisible(`#${helpbox.id}`);
			}
		}
	});
	onEvent(context, ".v3-helpbox__title", "click", (_, title) => {
		const helpbox = title.closest(".v3-helpbox");
		const button = (context || document).querySelector(`[aria-controls="${helpbox.id}"]`);
		toggleHelp(button, helpbox, false);
	});
}

export { init };